/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const GET_REALM_SETTINGS_START = 'GET_REALM_SETTINGS_START';
export const GET_REALM_SETTINGS_SUCCESS = 'GET_REALM_SETTINGS_SUCCESS';
export const GET_REALM_SETTINGS_FAILURE = 'GET_REALM_SETTINGS_FAILURE';
export const SET_REALM_INFO = 'SET_REALM_INFO';